import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Notification from "./notification";
import Tips from "./Tips";

import { connect } from "react-redux";

class StudentDashboardPage extends Component {
  constructor() {
    super();

    this.state = {
      notifations: [
        {
          message: "Invite a friend, earn 20",
          date: "Nov 20",
        },
      ],
      TipsData: [
        {
          icon: "message.png",
          text: "Purse your inspiration with an inspiring event",
          linkAction: "Event",
        },
        {
          icon: "question.png",
          text: "Request a tutor for a specific topic or skill",
          linkAction: "Request",
        },
        {
          icon: "message.png",
          text: "Find a small group courses lead by expert tutors",
          linkAction: "Classes",
        },
      ],
    };
  }

  render() {
    const { notifations, TipsData } = this.state;

    return (
      <div className="container">
        <div className="Dashboard-div">
          <Row className="flex-center">
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ marginBottom: "70px", padding: "0px" }}
            >
              <Row className="flex-center" style={{ margin: "0px" }}>
                <Col lg={6} md={6} sm={6} xs={6} style={{ padding: "0px" }}>
                  <div className="header">
                    <h2>Dashboard</h2>
                  </div>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="live-style flex-center"
                ></Col>
              </Row>
            </Col>

            <Col lg={7} md={7} sm={12} xs={12} style={{ "padding-left": 0 }}>
              <div className="session-request">
                <Row className="flex-center">
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <Row className="flex-center" style={{ marginBottom: "25px" }}>
                      <Col lg={6} md={6} sm={12} xs={12}>
                        <div className="header">
                          <h4>Upcoming lessons</h4>
                        </div>
                      </Col>
                    </Row>
                    <div style={{ marginBottom: "67px", fontSize: "18px" }}>
                      {" "}
                      You are up to date on your lesson requests{" "}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg={5} md={5} sm={12} xs={12} style={{ "padding-left": 0 }}>
              <Notification notifations={notifations} />
            </Col>

            <Col lg={7} md={7} sm={12} xs={12} style={{ "padding-left": 0 }}>
              <Tips TipsData={TipsData} />
            </Col>
            <Col lg={5} md={5} sm={12} xs={12}></Col>
          </Row>
          <Row style={{ paddingLeft: "4px" }}>
            <span
              style={{
                fontSize: "17px",
                color: "#025277",
                borderBottom: "1px solid",
                marginBottom: "40px",
              }}
            >
              Give us feedback
            </span>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    UserReducer: { user },
  } = state;
  return {
    user,
  };
};
export default connect(mapStateToProps, null)(StudentDashboardPage);
